import { useTheme } from "@mui/material";
import React from "react";

function Hello() {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="979.327"
      height="424.837"
      data-name="Layer 1"
      viewBox="0 0 979.327 424.837"
    >
      <path
        fill="#ccc"
        d="M883.382 175.258H308.805a9.199 9.199 0 000 18.397h16.275v220.066a9.199 9.199 0 0018.398 0l.14-220.066h461.156l42.52 220.066a9.199 9.199 0 1018.397 0l2.677-220.066h15.014a9.199 9.199 0 000-18.397z"
      ></path>
      <path
        fill="#f2f2f2"
        d="M408.4 134.269v38.954h-97.596a19.49 19.49 0 11-1.355-38.954q.678-.024 1.355 0z"
      ></path>
      <path
        fill={theme.palette.primary.main}
        d="M410.798 172.924a1.499 1.499 0 01-1.498 1.498H309.066a20.526 20.526 0 010-41.052H409.3a1.498 1.498 0 110 2.996H309.066a17.53 17.53 0 000 35.06H409.3a1.499 1.499 0 011.498 1.498z"
      ></path>
      <path
        fill="#ccc"
        d="M408.4 143.258H303.523a.3.3 0 01-.005-.599H408.4a.3.3 0 010 .6zM408.4 150.45H303.523a.3.3 0 01-.005-.6H408.4a.3.3 0 010 .6zM408.4 157.642H303.523a.3.3 0 01-.005-.6H408.4a.3.3 0 010 .6zM408.4 164.833H303.523a.3.3 0 01-.005-.6H408.4a.3.3 0 010 .6z"
      ></path>
      <path
        fill="#f2f2f2"
        d="M390.003 93.228v38.954h-97.596a19.49 19.49 0 01-1.356-38.954q.678-.024 1.356 0z"
      ></path>
      <path
        fill="#3f3d56"
        d="M392.4 131.883a1.499 1.499 0 01-1.498 1.498H290.668a20.526 20.526 0 010-41.052h100.234a1.498 1.498 0 110 2.996H290.668a17.53 17.53 0 000 35.06h100.234a1.499 1.499 0 011.498 1.498z"
      ></path>
      <path
        fill="#ccc"
        d="M390.003 102.217H285.125a.3.3 0 01-.006-.6h104.884a.3.3 0 010 .6zM390.003 109.409H285.125a.3.3 0 01-.006-.6h104.884a.3.3 0 010 .6zM390.003 116.6H285.125a.3.3 0 01-.006-.599h104.884a.3.3 0 010 .6zM390.003 123.792H285.125a.3.3 0 01-.006-.6h104.884a.3.3 0 010 .6zM503.537 313.102v-33.965a5.661 5.661 0 00-5.66-5.661H369.091a5.661 5.661 0 00-5.661 5.66v33.966z"
      ></path>
      <path fill="#ccc" d="M363.431 325.839H503.537V369.711H363.431z"></path>
      <path
        fill="#ccc"
        d="M363.43 382.447v33.965a5.661 5.661 0 005.662 5.661h128.784a5.661 5.661 0 005.66-5.66v-33.966z"
      ></path>
      <circle cx="432.776" cy="294.704" r="4.246" fill="#fff"></circle>
      <circle cx="432.776" cy="351.313" r="4.246" fill="#fff"></circle>
      <circle cx="433.004" cy="406.722" r="4.246" fill="#fff"></circle>
      <path
        fill="#f2f2f2"
        d="M487.652 234.749v38.955h-97.596a19.49 19.49 0 01-1.356-38.955q.678-.024 1.356 0z"
      ></path>
      <path
        fill="#3f3d56"
        d="M490.05 273.404a1.499 1.499 0 01-1.498 1.498H388.318a20.526 20.526 0 01-.025-41.052h100.259a1.498 1.498 0 110 2.996H388.318a17.53 17.53 0 000 35.06h100.234a1.499 1.499 0 011.498 1.498z"
      ></path>
      <path
        fill="#ccc"
        d="M487.652 243.738H382.774a.3.3 0 01-.005-.599h104.884a.3.3 0 010 .6zM487.652 250.93H382.774a.3.3 0 01-.005-.6h104.884a.3.3 0 010 .6zM487.652 258.122H382.774a.3.3 0 01-.005-.6h104.884a.3.3 0 010 .6zM487.652 265.313H382.774a.3.3 0 01-.005-.6h104.884a.3.3 0 010 .6z"
      ></path>
      <path
        fill="#3f3d56"
        d="M373.03 80.232h-44.465a2.747 2.747 0 00-1.217.284l-11.223 5.618a2.045 2.045 0 000 3.764l11.223 5.619a2.747 2.747 0 001.217.283h44.466a2.334 2.334 0 002.463-2.166V82.398a2.334 2.334 0 00-2.463-2.166z"
      ></path>
      <path
        fill={theme.palette.primary.main}
        d="M375.494 82.398v11.236a2.334 2.334 0 01-2.463 2.166h-8.859V80.232h8.859a2.334 2.334 0 012.463 2.166z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M106.444 300.412a35.34 35.34 0 0034.126-6.012c11.952-10.032 15.7-26.56 18.75-41.864l9.018-45.266-18.882 13.002c-13.579 9.35-27.464 18.999-36.866 32.542s-13.506 32.03-5.952 46.684"
      ></path>
      <path
        fill="#f2f2f2"
        d="M108.058 355.216c-1.91-13.921-3.876-28.02-2.535-42.09 1.19-12.496 5.002-24.7 12.764-34.708a57.736 57.736 0 0114.813-13.423c1.48-.935 2.844 1.413 1.37 2.344a54.888 54.888 0 00-21.712 26.196c-4.727 12.023-5.486 25.128-4.671 37.9.492 7.723 1.536 15.396 2.588 23.06a1.406 1.406 0 01-.947 1.668 1.365 1.365 0 01-1.67-.947z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M126.466 330.583a26.014 26.014 0 0022.666 11.698c11.475-.544 21.04-8.553 29.651-16.155l25.47-22.488-16.857-.807c-12.122-.58-24.557-1.121-36.103 2.617s-22.195 12.735-24.306 24.686"
      ></path>
      <path
        fill="#f2f2f2"
        d="M102.657 363.218c9.199-16.276 19.868-34.365 38.933-40.147a43.445 43.445 0 0116.376-1.69c1.738.15 1.304 2.83-.431 2.68a40.361 40.361 0 00-26.133 6.913c-7.369 5.016-13.106 11.989-17.962 19.383-2.974 4.53-5.639 9.251-8.303 13.966-.852 1.507-3.341.42-2.48-1.105z"
      ></path>
      <path
        fill="#f2f2f2"
        d="M87.919 380.35a19.698 19.698 0 0112.07-16.498v-9.41h15.783v9.706a19.688 19.688 0 0111.413 16.202l3.711 43.138H84.208z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M624.636 174.373l-4.694-1.977-3.221-23.535h-42.89l-3.49 23.44-4.2 2.1a.997.997 0 00.446 1.889h57.662a.997.997 0 00.387-1.917z"
      ></path>
      <path
        fill="#ccc"
        d="M700.853 151.992H490.17a4.174 4.174 0 01-4.164-4.174V118.11h219.012v29.71a4.174 4.174 0 01-4.165 4.173z"
      ></path>
      <path
        fill="#3f3d56"
        d="M705.238 132.15H485.813V5.032A5.037 5.037 0 01490.845 0h209.361a5.038 5.038 0 015.032 5.032z"
      ></path>
      <path
        fill="#fff"
        d="M692.133 122.924H498.919a3.883 3.883 0 01-3.88-3.879V13.105a3.884 3.884 0 013.88-3.879h193.214a3.884 3.884 0 013.879 3.88v105.94a3.883 3.883 0 01-3.88 3.878z"
      ></path>
      <path
        fill="#ffb6b6"
        d="M641.243 160.305a11.616 11.616 0 0117.666 2.272l26.134-4.646 6.698 15.193-37 6.043a11.679 11.679 0 01-13.498-18.862z"
      ></path>
      <path
        fill={theme.palette.primary.main}
        d="M665.44 179.704l27.245-.34 3.449-.046 55.433-.698s15.053-14.361 28.16-29.147l-1.837-13.288a54.292 54.292 0 00-18.204-33.615c-18.773 12.544-29.66 37.374-29.66 37.374l-34.37 8.22-3.438.823-21.356 5.103z"
      ></path>
      <path
        fill="#e4e4e4"
        d="M804.913 261.38h-50.857c0 2.18-55.594 3.948-55.594 3.948a20.309 20.309 0 00-3.332 3.158 19.597 19.597 0 00-4.58 12.633v3.158a19.746 19.746 0 0019.739 19.738h94.624a19.756 19.756 0 0019.74-19.738v-3.158a19.766 19.766 0 00-19.74-19.739z"
      ></path>
      <path
        fill="#e4e4e4"
        d="M747.402 303.231H767.9300000000001V421.721H747.402z"
      ></path>
      <path
        fill="#e4e4e4"
        d="M688.976 421c0 2.218 31.107.858 69.48.858s69.48 1.36 69.48-.858-31.108-19.807-69.48-19.807-69.48 17.589-69.48 19.807z"
      ></path>
      <path
        fill="#ffb6b6"
        d="M675.186 407.461L659.908 407.46 652.64 348.531 675.188 348.532 675.186 407.461z"
      ></path>
      <path
        fill="#2f2e41"
        d="M679.082 422.27l-49.262-.002v-.623a19.175 19.175 0 0119.174-19.174h.001l30.088.002z"
      ></path>
      <path
        fill="#ffb6b6"
        d="M630.031 407.461L614.753 407.46 607.485 348.531 630.033 348.532 630.031 407.461z"
      ></path>
      <path
        fill="#2f2e41"
        d="M633.927 422.27l-49.262-.002v-.623a19.175 19.175 0 0119.174-19.174h.001l30.088.002z"
      ></path>
      <circle cx="766.887" cy="41.636" r="26.564" fill="#ffb6b6"></circle>
      <path
        fill="#2f2e41"
        d="M809.88 223.642s8.913 47.131-25 53.133-82.866 10.22-82.866 10.22L680.03 389.562l-29.534-2.637s3.928-123.468 13.588-133.127 70.712-38.583 70.712-38.583z"
      ></path>
      <path
        fill="#2f2e41"
        d="M743.646 203.89l-14.832 14.879s-107.094 17.25-111.225 41.985c-6.238 37.344-13.605 118.552-13.605 118.552l32.199-2.415 12.626-92.311 51.518-11.719 58.614-31.943zM792.449 25.78c-2.623-4.948-5.954-14.808-11.247-16.637a42.077 42.077 0 00-9.059-1.93l-8.996 3.46 4.896-3.808q-1.43-.085-2.858-.139l-6.07 2.334 3.106-2.415c-5.659-.058-11.5.53-15.885 3.975-3.738 2.937-7.442 14.062-8.04 18.778a35.917 35.917 0 00.66 13.53l1.537 1.462a18.86 18.86 0 001.206-3.839 18.18 18.18 0 018.703-11.806l.083-.047c2.579-1.451 5.707-1.384 8.663-1.278l14.042.505c3.378.122 7.016.336 9.65 2.455a15.888 15.888 0 013.858 5.589c1.309 2.641 3.866 12.604 3.866 12.604s1.447-1.88 2.14-.48a48.398 48.398 0 002.015-11.234 22.009 22.009 0 00-2.27-11.08z"
      ></path>
      <path
        fill="#ffb6b6"
        d="M885.358 53.302a11.616 11.616 0 00-10.514 14.378l-21.361 15.757 6.41 15.317 29.853-22.676a11.679 11.679 0 00-4.388-22.776z"
      ></path>
      <path
        fill={theme.palette.primary.main}
        d="M881.92 85.47l-53.551 59.475s-25.61-8.198-45.415-17.087l-8.898-27.327a54.343 54.343 0 01-2.6-19.665c27.455-7.306 59.39 19.879 59.39 19.879l40.085-31.399z"
      ></path>
      <path
        fill={theme.palette.primary.main}
        d="M756.964 228.035c-9.554-3.3-19.433-6.713-30.089-7.994l-.457-.055.126-.443c11.03-38.73 8.277-63.507 2.872-100.723a37.59 37.59 0 0121.548-39.501l.066-.03 30.434-1.934.07-.004 22.134 6.51a15.183 15.183 0 0110.867 14.831c-.24 12.24.269 25.904.807 40.371 1.208 32.456 2.457 66.017-4.63 87.792l-.038.114-.094.074a36.099 36.099 0 01-23.081 8.108c-9.935 0-20.074-3.502-30.535-7.116z"
      ></path>
      <path
        fill="#ccc"
        d="M977.912 424.837H1.415a1.415 1.415 0 110-2.83h976.497a1.415 1.415 0 110 2.83z"
      ></path>
    </svg>
  );
}

export default Hello;
